import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import DistMain from "../pages/DistMain";
import NavBar from "../components/NavBar";
import useMenu from "../utils/Hooks/useMenu";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.DHome,
    key: "",
  };

  return (
    <ValidateURL currentPage={currentPage}>
      <LocalizationContext.Provider value={null}>
        <NavBar
          MenuOptions={menu}
          currentPage={currentPage}
        >
          <DistMain />
        </NavBar>
      </LocalizationContext.Provider>
    </ValidateURL>
  );
};

